import React, { ReactElement, useEffect, useState } from 'react';
import Slider from 'rc-slider';
import './progressBar.scss';
import { AudioPlayerDataType } from '@/modules/types/audioPlayer';
import { useDispatch, useSelector } from 'react-redux';
import { actions as AudioPlayerActions } from '@/components/Player/modules/reducers/audioPlayer';
import { ElearningPlayerStateType } from '@/components/Player/modules/reducers/elearningPlayer';

const ProgressBar = (): ReactElement => {
  const [currentValue, setCurrentValue] = useState<number>(0);
  const [maxDuration, setMaxDuration] = useState<number>(0);

  const audioPlayer: AudioPlayerDataType = useSelector(
    (state: { audioPlayer: AudioPlayerDataType }) => state.audioPlayer,
  );

  const {
    content: { frames, currentFrameId },
  } = useSelector(
    (state: { elearningPlayer: ElearningPlayerStateType }) =>
      state.elearningPlayer,
  );

  const dispatch = useDispatch();

  function handleOnChange(value: any) {
    dispatch({
      type: AudioPlayerActions.seekAudio.type,
      payload: value,
    });
    // need to re-render slider after the seek is updated
    setCurrentValue(audioPlayer.howler.seek());
  }
  useEffect(() => {
    if (audioPlayer.howler && audioPlayer.playing) {
      // update the state after 60 milisecond to re-render the slider
      setTimeout(() => {
        setCurrentValue(audioPlayer.howler.seek());
      }, 60);
    }
  });

  useEffect(() => {
    // Reset the voice over on slide navigation
    const currentFrame = frames
      ? currentFrameId
        ? frames?.find((frameElement) => frameElement.id === currentFrameId)
        : frames[0]
      : undefined;
    if (currentFrame && currentFrame.frameMetadata.sound === '') {
      dispatch({
        type: AudioPlayerActions.stopAudio.type,
      });
    }
  }, [frames]);

  useEffect(() => {
    // resets progress bar to 0 & maxduration when changing frame or audio howler instance
    setCurrentValue(0);
    if (audioPlayer.howler) {
      setMaxDuration(audioPlayer.howler.duration());
    }
  }, [currentFrameId, audioPlayer.howler]);

  return (
    audioPlayer.howler && (
      <Slider
        key={currentFrameId}
        min={0}
        max={maxDuration}
        defaultValue={0}
        value={currentValue}
        onChange={(value) => {
          handleOnChange(value);
        }}
        className=""
      />
    )
  );
};

export default ProgressBar;
